var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 9
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.499 5.253L7.776 7.976a.805.805 0 01-1.139-1.138L8.02 5.456H1.715a.804.804 0 110-1.609H8.1L6.598 2.343a.805.805 0 011.138-1.138l2.724 2.724c.14.14.217.318.232.5.094.28.03.6-.193.824z",
    fill: "#3A92E5",
    fillRule: "evenodd"
  })));
}
export default SvgRightArrow;